<phx-widget-delivery-item-list
    *ngIf="documentId"
    #addEditDeliveryItemWidget
    [documentId]="documentId"
    [documentStatus]="documentStatus()"
    [autoFocusSearch]="false"
/>
